export type InfluencerPixKeyType = 'CPF' | 'EMAIL' | 'PHONE';

export const INFLUENCER_PIX_KEY_TYPES: { value: InfluencerPixKeyType; label: string }[] = [
  { value: 'CPF', label: 'CPF' },
  { value: 'EMAIL', label: 'E-mail' },
  { value: 'PHONE', label: 'Telefone' },
];
